module.exports = __webpack_public_path__ + "static/img/WeChat.a11c0ff6.png";